import React from 'react';
import PropTypes from 'prop-types';
import componentBase from '../../lib/component-base';

@componentBase('MapControlBase')
export default class MapControlBase extends React.Component {
  static propTypes = {
    hide: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.control = null;
  }

  reset() {
    const component = this;
    return function () { // eslint-disable-line func-names
      const container = this.getContainer();

      if (container) {
        container.style.display = (component.props.hide ? 'none' : null);
      }
    };
  }

  render() {
    if (this.control) {
      this.control.reset(this);
    }

    return (<div />);
  }
}



// WEBPACK FOOTER //
// ./src/components/MapControlsAndLayers/MapControlBase.js